import {TabState, TabStateDefaults} from 'Navigation';

export default class ChildEntityTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Child entity tab',
      closeable: false,
      preferenceKey: 'child-entity-tab',
    };
  }
}
